import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer, Icon, Text } from '..';

const AlertLabelContainer = styled.button`
    min-height: 30px;
    max-height: 30px;
    border: none;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 6px;
    font-size: 12px;
    width: ${({ $width }) => $width || '100%'};
    margin: ${({ $margin }) => $margin || '8px 0'};
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

    ${({ type }) => (type === 'success' || type == 'small') && css`
        background-color: rgb(230, 245, 241);
        border: 1px solid #1fa02e;

        ${({ onClick }) => onClick && css`
            &:hover {
                background-color: rgb(210, 235, 230); // ligeramente más oscuro
            }
        `}
    `}

    ${({ type }) => (type === 'error' || type == 'large') && css`
        background-color: #f9e6e8;
        border: 1px solid #ed606f;

        ${({ onClick }) => onClick && css`
            &:hover {
                background-color: #f4cdd2;
            }
        `}
    `}

    ${({ type }) => type === 'medium' && css`
        background-color:rgb(255, 242, 208);
        border: 1px solid #EB963C;
    `}
`;

const Separator = styled.span`
    display: inline-block;
    width: 1px;
    height: 16px;
    background-color: ${({ color }) => color || '#cc2c3b'};
    margin: 0 5px;
`;

const getIconName = (type, isSemaphore) => {
    if (isSemaphore) return 'circle';
    if (type === 'success') return 'checkmark-circle';
    if (type === 'error') return 'alert-circle';
}

const getColorSemaphore = (type) => {
    if (type === 'small') return '#1fa02e';
    if (type === 'medium') return '#EB963C';
    if (type === 'large') return '#cc2c3b';
}

const getColor = (type, isSemaphore) => {
    if (isSemaphore) {
        return getColorSemaphore(type)
    }
    if (type === 'success') return '#1fa02e';
    if (type === 'error') return '#cc2c3b';
}

const AlertLabel = ({ text, type, iconSize = 19, isSemaphore, hideSeparator = false, width, margin, onClick }) => {
    const color = getColor(type, isSemaphore);
    const iconName = getIconName(type, isSemaphore);

    return (
        <AlertLabelContainer type={type} $width={width} $margin={margin}  onClick={onClick}>
            <FlexContainer align="center">
                <Icon name={iconName} size={iconSize} color={color} />
                {!hideSeparator && <Separator color={color} />}
                <Text text={text} style={{ fontWeight: '600' }}/>
                <Icon name={'arrow-right'} size={'16'} color={color} style={{ margin: '0px 0px 0px 10px' }}/>
            </FlexContainer>
        </AlertLabelContainer>
    );
};

AlertLabel.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'semaphore']).isRequired,
    onClick: PropTypes.func,
};

export default AlertLabel;